module.exports = __webpack_public_path__ + "img/lens-167-plus-04.c8df1cc9.png";